import { Tooltip } from "antd";
import { ColumnType } from "antd/es/table";
import { CompanyEntity, USER_SCOPE_TEXTS, UserListEntity, UserStatus } from "interfaces";
import { Status } from "ui";
import { dateFormat, getPhone } from "utils";
import { RemoveUserFromCompanyButton } from "./RemoveUserFromCompanyButton";
import { UserRoleList } from "components";
import { UserStore } from "stores/UserStore";

import styles from "./userList.module.css";

export const getColumns = (companyInfo: CompanyEntity, user: UserStore): Array<ColumnType<UserListEntity>> => {
  const { isUserAdmin } = user.roles;

  return [
    {
      dataIndex: "surname",
      key: "surname",
      title: "ФИО",
      width: 260,
      className: `text-clamp-ellipsis ${styles.userFullName}`,
      render: (_: any, record: UserListEntity) => {
        return (
          <Tooltip
            trigger="hover"
            placement="topLeft"
            title={`${record.surname} ${record.name} ${record.secondName ?? ""}`}
          >
            <span>
              {record.surname} {record.name} {record.secondName ?? ""}
            </span>
          </Tooltip>
        );
      },
    },
    {
      dataIndex: "phone",
      key: "phone",
      title: "Телефон",
      width: 200,
      render: (phone: number) => {
        return getPhone(phone);
      },
    },
    {
      dataIndex: "statusDate",
      key: "statusDate",
      title: "Дата обновления",
      width: 180,
      render: (statusDate: Date | string) => {
        return dateFormat(statusDate, true);
      },
    },
    {
      dataIndex: "roles",
      key: "roles",
      title: "Роль пользователя",
      width: 200,
      render: (_: any, record: UserListEntity) => {
        return record.roles ? (
          <UserRoleList
            roles={record.roles}
            companyInfo={{
              id: companyInfo.id,
              companyName: companyInfo.companyName,
              companyRegistrationNumber: companyInfo.companyRegistrationNumber,
              role: companyInfo.role,
            }}
            userInfo={record}
          />
        ) : null;
      },
    },
    {
      dataIndex: "status",
      key: "statuses",
      title: "Статус",
      align: "left",
      width: 130,
      render: (status: UserStatus) => {
        return <Status color={USER_SCOPE_TEXTS.colors[status]} children={USER_SCOPE_TEXTS.texts[status]} />;
      },
    },
    isUserAdmin && {
      dataIndex: "id",
      key: "remove",
      align: "right",
      width: 20,
      render: (id: string) => {
        return <RemoveUserFromCompanyButton userId={id} />;
      },
    },
  ].filter((c) => !!c) as ColumnType<UserListEntity>[];
};
